import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import Trix from "trix";
import "@rails/actiontext";
import * as ActiveStorage from "@rails/activestorage";

import "trix/dist/trix.css";
import "./styles/custom.css";

ActiveStorage.start();
window.Trix = Trix;

const isYoutubeUrl = (url) => {
  return /youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\//.test(url);
};

document.addEventListener("trix-before-paste", (event) => {
  const pastedText = event.paste?.string?.trim();
  if (!pastedText || !isYoutubeUrl(pastedText)) return;

  event.preventDefault();

  event.target.editor.insertHTML(
    `<a href="${pastedText}" data-youtube-embed="true">${pastedText}</a>`
  );
});

// Function to dynamically load a React component
const loadComponent = async (name) => {
  try {
    const module = await import(`./components/${name}.jsx`);
    return module.default;
  } catch (error) {
    console.error(`Component "${name}" not found:`, error);
    return null;
  }
};

// Auto-mount React components found in the DOM
document.addEventListener("DOMContentLoaded", async () => {
  const elements = document.querySelectorAll("[react-component]");

  for (const element of elements) {
    const componentName = element.getAttribute("react-component");
    const Component = await loadComponent(componentName);

    if (Component) {
      const props = JSON.parse(element.getAttribute("props") || "{}");
      ReactDOM.createRoot(element).render(<Component {...props} />);
    }
  }
});

window.React = React;
window.ReactDOM = ReactDOM;